import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as MDICONS from '@material-ui/icons';
import styled from "styled-components";
import { setCurrentProjectId } from '../../store/actions/projectActions';
import * as ROUTES from '../../constants/routes';
import { Link } from "react-router-dom";
import moment from 'moment';
import $ from "jquery";
import { Handler } from 'leaflet';
const ProjectSearchButton = styled.div`
.btn {
    color: ${(props) => props.themeColors.backgroundColor};
    border-color: ${(props) => props.themeColors.invisibleColor};
    background-color: ${(props) => props.themeColors.invisibleColor};
    margin: 0px;

    &:hover {
        color: ${(props) => props.themeColors.backgroundColor};
        background-color: ${(props) => props.themeColors.themeColor};
    }

    &:active {
        color: ${(props) => props.themeColors.backgroundColor};
        background-color: ${(props) => props.themeColors.themeColor};
    }
}
`;

const ViewDashboardButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: #fafafa;
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

class ProjectDrawer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            projectTitleToFilter: '',
            
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    checkValidSearch = () => {
        const { projectTitleToFilter } = this.state;
        return (projectTitleToFilter === "" || projectTitleToFilter.startsWith(" ")) === false;
    }


    filterBySearch = (s) => {
        const { projectTitleToFilter } = this.state;
        var sProjectTitle = `${s.projectTitle}`;
        return sProjectTitle.toLowerCase().startsWith(projectTitleToFilter.toLowerCase());
    }
    closeDropDown = ()=> {
        // $("a.download").click(function() {
        //     $("#menu").dropdown("toggle");
        //  });
        console.log("close")
        $(".dropdown-menu a").click(function() {
            $(this).closest(".dropdown-menu").prev().dropdown("toggle");
        });
   }
  

   
    


    render() {
        const { allProjects, themeColors,userData,companyData } = this.props;
        let subscriptionBoughtActive = false;
        if (userData.coid !== '-1') {
            let boughtOrderId = companyData ? 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null : null;
            subscriptionBoughtActive = boughtOrderId ? companyData.boughtSubscription.applied : false
        } else {
            subscriptionBoughtActive = true;
        }
        // console.log(allProjects)
        return (
            <div className="section">
                <div>
                    <div className="dropdown">
                        <ProjectSearchButton themeColors={themeColors}>
                            <button className="btn btn-flat btn-xs " id="menu" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {/* <div class="input-group input-group-sm">
                                <input style={{width:'400px'}} type="search" class="form-control" placeholder="Search or jump to..." aria-controls="jump" aria-label="Search or jump to..." />
                            </div> */}
                                <MDICONS.Search />
                            </button>

                            <form className="dropdown-menu ml-3 p-2"  aria-labelledby="menu" style={{ borderRadius: '10px', width: "500px", maxHeight: "500px", overflowY: "auto", margin: '0px', zIndex: '2', position: 'absolute' }}>


                                <input type="text" className="form-control mb-2 mt-1" id="projectTitleToFilter" onChange={this.handleChange} placeholder="Search a title" />
                                {allProjects && allProjects.filter(this.filterBySearch).slice(0, 4).map(eachProject => {
                                    var parsedDate = new Date(eachProject.dateCreated ? eachProject.dateCreated.seconds + eachProject.dateCreated.nanoseconds * 10 ** -9 : '');
                                    var date = moment(parsedDate * 1000).format('dddd, MMMM Do, YYYY');
                                    return (
                                        <ul className="list-group mb-2" key={eachProject.proid}>
                                            <li className="list-group-item" >
                                                <div className="row">
                                                    <div className="col col-8" style={{ fontWeight: "bold",fontSize:'14px' }}>{eachProject.projectTitle}</div>
                                                    <div className="col col-4">
                                                        {/* data-toogle = "dropdown" is the property to close dropdown */}
                                                        <ViewDashboardButton themeColors={themeColors}>
                                                         {subscriptionBoughtActive ? <Link to={ROUTES.IND_PROJECT_DASHBOARD} style={{ borderRadius: '10px' }} className="btn btn-default btn-sm" onClick={() => {this.closeDropDown();this.props.setCurrentProjectId(eachProject.proid)}}>Open project</Link>
                                                        :<Link to={ROUTES.PRICING} className="btn btn-default btn-sm " style={{ borderRadius: '10px' }} >Upgrade your plan</Link>}
                                                        </ViewDashboardButton>
                                                        {/* <ViewDashboardButton themeColors={themeColors}>
                                                            <a href={ROUTES.IND_PROJECT_DASHBOARD} className="btn btn-default btn-sm" onClick={() => this.props.setCurrentProjectId(eachProject.proid)}>Open project</a>
                                                        </ViewDashboardButton> */}
                                                    </div>
                                                    {/* <div className="p-2" style={{ fontWeight: "bold" }}>{eachProject.companyName}</div> */}
                                                </div>
                                                <div className="d-flex justify-content-start">
                                                    <p style={{ color: 'grey', fontSize: '12px' }}>{date}</p>
                                                    {/* <div className="p-2">
                                       <ViewDashboardButton themeColors={themeColors}>
                                           <Link to={ROUTES.IND_PROJECT} className="btn btn-default btn-sm" onClick={() => this.props.setCurrentProjectId(eachProject.proid)}>Open project</Link>
                                       </ViewDashboardButton>
                                   </div> */}
                                                </div>
                                            </li>
                                        </ul>
                                    );
                                })}
                                {/* {allProjects && this.checkValidSearch() && allProjects.filter(this.filterBySearch).map(eachProject => {
                                return (

                                    <li className="card p-2 m-1" key={eachProject.proid}>
                                        <div className="d-flex justify-content-between" >
                                            <div className="p-2" style={{ fontWeight: "bold" }}>{eachProject.projectTitle}</div>
                                            <div className="p-2" style={{ fontWeight: "bold" }}>{eachProject.companyName}</div>
                                        </div>
                                        <div className="d-flex justify-content-start">
                                            <div className="p-2">
                                                <ViewDashboardButton themeColors={themeColors}>
                                                    <Link to={ROUTES.IND_PROJECT} className="btn btn-default btn-sm" onClick={() => this.props.setCurrentProjectId(eachProject.proid)}>Open project</Link>
                                                </ViewDashboardButton>
                                            </div>
                                        </div> 
                                    </li>

                                )

                            })} */}
                            </form>
                        </ProjectSearchButton>
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        allProjects: state.firestore.ordered.Projects,
        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentProjectId: (proid) => dispatch(setCurrentProjectId(proid)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDrawer);
